// extracted by mini-css-extract-plugin
module.exports = {"edit":"index--edit--3V3dM"};